import React from "react";

/**
 * xaelserpent yellow thunderbird logo component.
 * Uses the asset placed in /public/yellow.png.
 */
export default function Logo({ className = "", alt = "xaelserpent logo", ...rest }) {
  return <img src="/yellow.png" alt={alt} className={className} {...rest} />;
}
